"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import { useInstituteAuth } from "../../context/InstituteAuthContext";
import HeaderMain from "../../dasboard-component/Components/HeaderMain";

// Import sport-specific components
import GolfMatchDetails from "../../CreateGamesModule/components/GolfMatchDetails";
import TableTennisMatchDetails from "../../CreateGamesModule/components/TableTennisMatchDetails";
import TennisMatchDetails from "../../CreateGamesModule/components/TennisMatchDetails";
import SnookerMatchDetails from "../../CreateGamesModule/components/SnookerMatchDetails";
import FootballMatchDetails from "../../CreateGamesModule/components/FootballMatchDetails";
import BasketballMatchDetails from "../../CreateGamesModule/components/BasketballMatchDetails";
import VolleyballMatchDetails from "../../CreateGamesModule/components/VolleyballMatchDetails";
import SquashMatchDetails from "../../CreateGamesModule/components/SquashMatchDetails";
import SwimmingEventDetails from "../../CreateGamesModule/components/SwimmingEventDetails";
import HockeyMatchDetails from "../../CreateGamesModule/components/HockeyMatchDetails";
import CricketMatchDetails from "../../CreateGamesModule/components/CricketMatchDetails";
import PadelTennisMatchDetails from "../../CreateGamesModule/components/PadelTennisMatchDetails";

const InstituteViewGame = () => {
  const [sportsOptions, setSportsOptions] = useState([]);
  const [selectedSport, setSelectedSport] = useState(null);
  const [gameRecords, setGameRecords] = useState([]);
  const [noRecordsMessage, setNoRecordsMessage] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [userNames, setUserNames] = useState({});

  const { instituteUser } = useInstituteAuth();
  const instituteId = instituteUser?.id;

  // Function to fetch user names by IDs
  const fetchUserNames = async (userIds) => {
    try {
      const idsToFetch = userIds.filter(id => id && id !== 'guest' && !userNames[id]);
      if (idsToFetch.length === 0) return;

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/user-add-game/api/selection/institute/user-names`,
        {
          params: {
            userIds: idsToFetch.join(',')
          },
          withCredentials: true,
        }
      );

      setUserNames(prev => ({ ...prev, ...response.data }));
    } catch (error) {
      console.error("Error fetching user names:", error);
    }
  };

  // Table styles for compatibility with existing components
  const styles = {
    setsTable: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "20px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      borderRadius: "8px",
      overflow: "hidden",
      fontSize: "14px",
      tableLayout: "fixed", // Helps with responsive layouts
    },
    tableTh: {
      backgroundColor: "#edf2f7",
      border: "1px solid #cbd5e0",
      padding: "8px 12px",
      textAlign: "center",
      fontWeight: "600",
      color: "#2d3748",
      fontSize: "13px",
      wordWrap: "break-word",
    },
    tableTd: {
      border: "1px solid #e2e8f0",
      padding: "8px 12px",
      textAlign: "center",
      color: "#4a5568",
      fontSize: "13px",
      wordWrap: "break-word",
    },
    container: {
      maxWidth: "800px",
      margin: "40px auto",
      padding: "30px",
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    sectionTitle: {
      fontSize: "24px",
      fontWeight: "600",
      color: "#2c3e50",
      marginBottom: "15px",
      textAlign: "center",
      position: "relative",
      paddingBottom: "10px",
    },
    titleUnderline: {
      content: "''",
      position: "absolute",
      bottom: "0",
      left: "50%",
      transform: "translateX(-50%)",
      width: "80px",
      height: "3px",
      backgroundColor: "#3498db",
      borderRadius: "2px",
    },
    selectionStep: {
      backgroundColor: "#f8fafc",
      borderRadius: "12px",
      padding: "25px",
      marginBottom: "20px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
      border: "1px solid #e2e8f0",
    },
    select: {
      width: "100%",
      padding: "12px",
      fontSize: "16px",
      borderRadius: "8px",
      border: "1px solid #cbd5e0",
      backgroundColor: "white",
      cursor: "pointer",
    },
    errorMessage: {
      color: "#e74c3c",
      fontWeight: "500",
      textAlign: "center",
      padding: "10px",
      backgroundColor: "#fdf2f2",
      borderRadius: "8px",
      marginTop: "10px",
      border: "1px solid #fed7d7",
    },
    gameCard: {
      backgroundColor: "#f8fafc",
      borderRadius: "12px",
      padding: "25px",
      marginBottom: "20px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
      border: "1px solid #e2e8f0",
      cursor: "pointer",
      transition: "all 0.3s ease",
    },
    viewButton: {
      padding: "12px 30px",
      fontSize: "16px",
      backgroundColor: "#3498db",
      color: "white",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontWeight: "600",
      boxShadow: "0 4px 6px rgba(52, 152, 219, 0.3)",
      transition: "all 0.3s ease",
    },
    modalBackdrop: {
      position: "fixed",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      backgroundColor: "rgba(0,0,0,0.7)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: "50",
      padding: "16px",
    },
    modalContent: {
      backgroundColor: "white",
      borderRadius: "16px",
      width: "100%",
      maxWidth: "800px",
      maxHeight: "90vh",
      boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
      display: "flex",
      flexDirection: "column",
    },
    modalHeader: {
      borderBottom: "2px solid #3498db",
      padding: "24px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    modalCloseButton: {
      backgroundColor: "#e74c3c",
      color: "white",
      border: "none",
      borderRadius: "50%",
      width: "40px",
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "20px",
      fontWeight: "bold",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    modalBody: {
      flex: "1",
      overflowY: "auto",
      padding: "24px",
    },
    modalFooter: {
      borderTop: "1px solid #e2e8f0",
      padding: "16px",
      textAlign: "center",
    },
    closeButton: {
      backgroundColor: "#6c757d",
      color: "white",
      border: "none",
      padding: "12px 24px",
      borderRadius: "8px",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
  };

  useEffect(() => {
    const fetchSportsOptions = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/common/get-sports`,
          { withCredentials: true }
        );
        
        // Filter out "General" sport and format options
        const formattedOptions = response.data
          .filter((sport) => sport.value !== "General")
          .map((sport) => ({
            value: sport.value,
            label: sport.value,
          }));
        setSportsOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching sports options:", error);
      }
    };
    fetchSportsOptions();
  }, []);

  useEffect(() => {
    const fetchGameRecords = async () => {
      if (!selectedSport || !instituteId) return;

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/user-add-game/api/selection/institute/game-records`,
          {
            params: {
              sport: selectedSport,
            },
            withCredentials: true,
          }
        );

        if (response.data && response.data.data) {
          const { data, message } = response.data;
          if (data.length === 0) {
            setNoRecordsMessage(
              message || `No game records found for ${selectedSport}`
            );
            setGameRecords([]);
          } else {
            setGameRecords(data);
            setNoRecordsMessage("");
          }
        } else {
          setNoRecordsMessage(`No game records found for ${selectedSport}`);
          setGameRecords([]);
        }
      } catch (error) {
        console.error("Error fetching institute game records:", error);
        setNoRecordsMessage("Failed to fetch game records");
        setGameRecords([]);
      }
    };
    fetchGameRecords();
  }, [selectedSport, instituteId]);


  const handleViewDetails = async (record) => {
    setSelectedRecord(record);
    setShowModal(true);

    // Fetch user names for all sports that store player IDs
    try {
      const results = typeof record.results === "string" ? JSON.parse(record.results) : record.results;
      
      // Handle different data structures - some sports store as arrays, others as single objects
      let matches;
      if (Array.isArray(results)) {
        matches = results;
      } else {
        matches = [results];
      }
      
      const allUserIds = [];
      
      matches.forEach(match => {
        // Golf player IDs - handle both direct match and nested structure
        if (match?.player1?.playerId && match.player1.playerId !== "guest") {
          allUserIds.push(match.player1.playerId);
        }
        if (match?.player2?.playerId && match.player2.playerId !== "guest") {
          allUserIds.push(match.player2.playerId);
        }
        
        // Snooker player IDs
        if (match?.playerA && match.playerA !== "guest") allUserIds.push(match.playerA);
        if (match?.playerB && match.playerB !== "guest") allUserIds.push(match.playerB);
        
        // Tennis player IDs (singles)
        if (match?.playerAId && match.playerAId !== "guest") allUserIds.push(match.playerAId);
        if (match?.playerBId && match.playerBId !== "guest") allUserIds.push(match.playerBId);
        
        // Tennis/Table Tennis doubles team IDs
        if (match?.teamA) {
          if (match.teamA.player1Id && match.teamA.player1Id !== "guest") allUserIds.push(match.teamA.player1Id);
          if (match.teamA.player2Id && match.teamA.player2Id !== "guest") allUserIds.push(match.teamA.player2Id);
        }
        if (match?.teamB) {
          if (match.teamB.player1Id && match.teamB.player1Id !== "guest") allUserIds.push(match.teamB.player1Id);
          if (match.teamB.player2Id && match.teamB.player2Id !== "guest") allUserIds.push(match.teamB.player2Id);
        }
        
        // Padel Tennis teams
        if (match?.teamA) {
          if (match.teamA.player1) allUserIds.push(match.teamA.player1);
          if (match.teamA.player2) allUserIds.push(match.teamA.player2);
        }
        if (match?.teamB) {
          if (match.teamB.player1) allUserIds.push(match.teamB.player1);
          if (match.teamB.player2) allUserIds.push(match.teamB.player2);
        }

        // Basketball, Football, Volleyball teams
        if (match?.userTeam) {
          match.userTeam.forEach(player => {
            if (player.userId) allUserIds.push(player.userId);
          });
        }
        if (match?.opponentTeam) {
          match.opponentTeam.forEach(player => {
            if (player.userId) allUserIds.push(player.userId);
          });
        }

        // Squash player IDs
        if (match?.playerAId && match.playerAId !== "guest") allUserIds.push(match.playerAId);
        if (match?.playerBId && match.playerBId !== "guest") allUserIds.push(match.playerBId);

        // Swimming participant IDs
        if (match?.participants) {
          match.participants.forEach(participant => {
            if (participant.userId && participant.userId !== "guest") {
              allUserIds.push(participant.userId);
            }
          });
        }
        if (match?.relayTeams) {
          match.relayTeams.forEach(team => {
            if (team.swimmers) {
              team.swimmers.forEach(swimmer => {
                if (swimmer.userId && swimmer.userId !== "guest") {
                  allUserIds.push(swimmer.userId);
                }
              });
            }
          });
        }

        // Hockey team player IDs
        if (match?.team1Players) {
          match.team1Players.forEach(player => {
            if (player.userId && player.userId !== "guest") {
              allUserIds.push(player.userId);
            }
          });
        }
        if (match?.team2Players) {
          match.team2Players.forEach(player => {
            if (player.userId && player.userId !== "guest") {
              allUserIds.push(player.userId);
            }
          });
        }

        // Cricket team player IDs
        if (match?.team1Players) {
          match.team1Players.forEach(player => {
            if (player.userId && player.userId !== "guest") {
              allUserIds.push(player.userId);
            }
          });
        }
        if (match?.team2Players) {
          match.team2Players.forEach(player => {
            if (player.userId && player.userId !== "guest") {
              allUserIds.push(player.userId);
            }
          });
        }
      });

      // Remove duplicates and fetch names
      const uniqueUserIds = [...new Set(allUserIds.filter(id => id && id !== "guest"))];
      if (uniqueUserIds.length > 0) {
        await fetchUserNames(uniqueUserIds);
      }
    } catch (error) {
      console.error("Error processing match data:", error);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedRecord(null);
  };

  // Handle ESC key press to close modal
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Escape' && showModal) {
        closeModal();
      }
    };

    if (showModal) {
      document.addEventListener('keydown', handleKeyPress);
      // Prevent body scrolling when modal is open
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.body.style.overflow = 'unset';
    };
  }, [showModal]);

  // Handle click outside modal to close
  const handleModalBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  // Render different game details based on sport type
  const renderGameDetails = (results) => {
    // Parse results if it's a string
    const parsedResults =
      typeof results === "string" ? JSON.parse(results) : results;

    // Handle different data structures - sometimes it's nested in arrays
    let firstMatch;
    if (Array.isArray(parsedResults)) {
      firstMatch = parsedResults[0];
    } else {
      firstMatch = parsedResults;
    }

    console.log("First match data:", firstMatch);
    console.log("Sport type:", selectedRecord?.sports_name);

    // Golf Detection - check for golf-specific properties
    if (
      firstMatch[0]?.player1 && 
      firstMatch[0]?.player2 && 
      firstMatch[0]?.pars &&
      firstMatch[0]?.holes !== undefined
    ) {
      return <GolfMatchDetails games={firstMatch} userNames={userNames} styles={styles} />;
    }
    // Hockey Detection (must come before generic team sports detection)
    else if (firstMatch?.team1Players && firstMatch?.team2Players && firstMatch?.periods && firstMatch?.goalEvents !== undefined) {
      return <HockeyMatchDetails matches={parsedResults} userNames={userNames} styles={styles} />;
    }
    // Team Sports Detection
    else if (
      firstMatch?.goalEvents !== undefined ||
      firstMatch?.penaltyEvents !== undefined
    ) {
      return <FootballMatchDetails matches={parsedResults} userNames={userNames} styles={styles} />;
    } else if (
      firstMatch?.quarters !== undefined &&
      firstMatch?.scoringEvents !== undefined
    ) {
      return <BasketballMatchDetails matches={parsedResults} userNames={userNames} styles={styles} />;
    } else if (
      firstMatch?.pointEvents !== undefined &&
      firstMatch?.substitutions !== undefined
    ) {
      return <VolleyballMatchDetails matches={parsedResults} userNames={userNames} styles={styles} />;
    } 
    // Table Tennis Detection (before Tennis to avoid conflicts)
    else if (firstMatch?.matchType && firstMatch?.games && firstMatch?.userGames !== undefined) {
      return <TableTennisMatchDetails matches={parsedResults} userNames={userNames} styles={styles} />;
    }
    // Padel Tennis Detection (specific to padel)
    else if (
      firstMatch?.sets && 
      firstMatch?.gameMode === "doubles" &&
      (firstMatch?.teamA !== undefined || firstMatch?.teamB !== undefined)
    ) {
      return <PadelTennisMatchDetails matches={parsedResults} userNames={userNames} styles={styles} />;
    }
    // Regular Tennis Detection 
    else if (firstMatch?.sets && firstMatch?.gameMode !== undefined) {
      return <TennisMatchDetails matches={parsedResults} userNames={userNames} styles={styles} />;
    } 
    // Snooker Detection
    else if (firstMatch?.gameType && firstMatch?.attempts !== undefined) {
      return <SnookerMatchDetails games={parsedResults} userNames={userNames} styles={styles} />;
    }
    // Squash Detection
    else if (firstMatch?.bestOf && firstMatch?.pointsToWin && firstMatch?.playerA !== undefined && firstMatch?.playerB !== undefined) {
      return <SquashMatchDetails matches={parsedResults} userNames={userNames} styles={styles} />;
    }
    // Swimming Detection
    else if (firstMatch?.eventType && firstMatch?.stroke && firstMatch?.distance && (firstMatch?.participants || firstMatch?.relayTeams)) {
      return <SwimmingEventDetails events={parsedResults} userNames={userNames} styles={styles} />;
    }
    // Cricket Detection  
    else if (firstMatch?.team1Players && firstMatch?.team2Players && firstMatch?.innings && firstMatch?.tossWinner) {
      return <CricketMatchDetails matches={parsedResults} userNames={userNames} styles={styles} />;
    }
    return <p>Unsupported game type</p>;
  };

  if (!instituteId) {
    return (
      <div style={{ minHeight: "100vh", backgroundColor: "#f8fafc", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ textAlign: "center" }}>
          <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "#2c3e50", marginBottom: "16px" }}>
            Institute Login Required
          </h2>
          <p style={{ color: "#718096", marginBottom: "24px" }}>
            You need to be logged in as an institute owner to access this page.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <HeaderMain pageType="InstituteViewGame" />

      <div style={styles.container}>
        <h1 style={styles.sectionTitle}>
          View Institute Scorecards
          <div style={styles.titleUnderline}></div>
        </h1>
        <div style={styles.selectionStep}>
          <div>
            <span style={{ display: "inline-block", width: "30px", height: "30px", backgroundColor: "#3498db", color: "white", borderRadius: "50%", textAlign: "center", lineHeight: "30px", marginRight: "10px", fontWeight: "bold" }}>1</span>
            <span style={{ display: "inline-block", fontSize: "20px", fontWeight: "600", color: "#2c3e50", marginBottom: "15px" }}>Select Sport</span>
          </div>
          <div style={{ marginBottom: "20px" }}>
            <select
              style={styles.select}
              value={selectedSport || ""}
              onChange={(e) => setSelectedSport(e.target.value)}
            >
              <option value="">Choose a sport...</option>
              {sportsOptions.map((sport) => (
                <option key={sport.value} value={sport.value}>
                  {sport.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {!selectedSport && (
          <div style={styles.selectionStep}>
            <p style={{ color: "#718096", fontWeight: "500", textAlign: "center", padding: "20px", backgroundColor: "#f7fafc", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
              Please select a sport to view your game records
            </p>
          </div>
        )}

        {selectedSport && noRecordsMessage && (
          <div style={styles.selectionStep}>
            <p style={styles.errorMessage}>
              {noRecordsMessage}
            </p>
          </div>
        )}

        {gameRecords.length > 0 && (
          <div style={{ marginTop: "20px" }}>
            {gameRecords.map((record) => (
              <div
                key={record.recordId}
                style={styles.gameCard}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.05)";
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #e2e8f0", paddingBottom: "16px", marginBottom: "16px" }}>
                  <h3 style={{ color: "#2c3e50", fontSize: "18px", fontWeight: "600" }}>{record.sports_name} Match</h3>
                  <span style={{ color: "#718096" }}>Record ID: {record.recordId}</span>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "16px" }}>
                  <p>
                    <span style={{ fontWeight: "600", color: "#2c3e50", marginRight: "4px" }}>Arena:</span>
                    <span style={{ color: "#4a5568" }}>
                      {record.Arena_name || "Guest Arena"}
                    </span>
                  </p>
                  <p>
                    <span style={{ fontWeight: "600", color: "#2c3e50", marginRight: "4px" }}>Created:</span>
                    <span style={{ color: "#4a5568" }}>
                      {new Date(record.created_at).toLocaleString()}
                    </span>
                  </p>
                </div>

                <div style={{ textAlign: "right" }}>
                  <button
                    onClick={() => handleViewDetails(record)}
                    style={styles.viewButton}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#2980b9";
                      e.currentTarget.style.boxShadow = "0 6px 8px rgba(52, 152, 219, 0.4)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#3498db";
                      e.currentTarget.style.boxShadow = "0 4px 6px rgba(52, 152, 219, 0.3)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showModal && selectedRecord && (
        <div
          style={styles.modalBackdrop}
          onClick={handleModalBackdropClick}
        >
          <div style={styles.modalContent}>
            {/* Fixed Header */}
            <div style={styles.modalHeader}>
              <h2 style={{ fontSize: "24px", fontWeight: "600", color: "#2c3e50", marginRight: "16px" }}>{selectedRecord.sports_name} Match Details</h2>
              <button
                onClick={closeModal}
                style={styles.modalCloseButton}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#c0392b";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#e74c3c";
                }}
                title="Close"
              >
                ×
              </button>
            </div>

            {/* Scrollable Content */}
            <div style={styles.modalBody}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "24px" }}>
                <p>
                  <span style={{ fontWeight: "600", color: "#2c3e50", marginRight: "4px" }}>Sport:</span>
                  <span style={{ color: "#4a5568" }}>
                    {selectedRecord.sports_name}
                  </span>
                </p>
                <p>
                  <span style={{ fontWeight: "600", color: "#2c3e50", marginRight: "4px" }}>Arena:</span>
                  <span style={{ color: "#4a5568" }}>
                    {selectedRecord.Arena_name || "Guest Arena"}
                  </span>
                </p>
                {selectedRecord.booking_date && selectedRecord.booking_time && (
                  <p>
                    <span style={{ fontWeight: "600", color: "#2c3e50", marginRight: "4px" }}>Booking:</span>
                    <span style={{ color: "#4a5568" }}>
                      {new Date(selectedRecord.booking_date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })} at {selectedRecord.booking_time}
                    </span>
                  </p>
                )}
                <p>
                  <span style={{ fontWeight: "600", color: "#2c3e50", marginRight: "4px" }}>Created:</span>
                  <span style={{ color: "#4a5568" }}>
                    {new Date(selectedRecord.created_at).toLocaleString()}
                  </span>
                </p>
              </div>

              <h3 style={{ marginBottom: "16px", borderBottom: "1px solid #e2e8f0", paddingBottom: "12px", color: "#2c3e50", fontSize: "20px", fontWeight: "500" }}>
                Match Details
              </h3>

              <div style={{ marginBottom: "16px", overflowX: "auto" }}>
                {renderGameDetails(selectedRecord.results)}
              </div>
            </div>

            {/* Fixed Footer */}
            <div style={styles.modalFooter}>
              <button
                onClick={closeModal}
                style={styles.closeButton}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#5a6268";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#6c757d";
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InstituteViewGame;

